export default "__VITE_ASSET__B0vc00cb__"